//include 8
jQuery(function(){    
    var weatherModules = $("[data-weather-update]");
    if(weatherModules.length == 0){
        return;
    }

    var todayTranslation = window.ppt.translate("today", "Heute");

    var weatherPromises = {};

    weatherModules.each(function(){
        var $this = $(this);
        var weather_id = $this.data("weather-id");
        var weather_tab = $this.data("weather-tab");
        if(!weather_id)
            return;
        if(!weather_tab)
            weather_tab = "poi";
        var weather_key = `${weather_id}_${weather_tab}`;
        if(!weatherModules[weather_key]){
            weatherModules[weather_key] = $.ajax({
                url:window.pixelpoint.utilities.getAjaxUrl(`/index.php?action=getWeather&type=1732176051`),
                method:'POST',
                dataType: "json",
                data:{
                    'weather_id':weather_id,
                    'weather_tab':weather_tab
                }
            });
        }
        weatherModules[weather_key].done(function(data){
            if(!data) {
                return;
            }

            var langObject = $("[data-language-obj]").data("language-obj") || {"id":0,"code":"de"};

            var today = moment().locale(langObject.code).format('DD. MM.');
            var tomorrow = moment().add(1,'day').locale(langObject.code).format(`dddd`);
            var overtomorrow = moment().add(2,'day').locale(langObject.code).format(`dddd`);
            $this.find("h4.capital-blue span").text(`${todayTranslation}, ${today}`);
            $this.find(".row.today .weather-icon").html(`<canvas class="weather-icon today" width="65" height="65" data-icon="${data.today.icon}"></canvas>`);
            //$this.find(".row.today .weather-icon").data("icon",data.today.icon);
            $this.find(".row.today .weather-info .temperature.big .min").text(data.today.temperatureMin);
            $this.find(".row.today .weather-info .temperature.big .max").text(data.today.temperatureMax);
            $this.find(".row.today .weather-info .temperature.big .min").text(data.today.temperatureMin);

            var shortSummary = data.today.summary;
            if(data.today.summary.length > 40){
                shortSummary = data.today.summary.substring(0, 40) + '...';
            }

            $this.find(".row.today .weather-info .switch-on-hover .show-on-normal").text(shortSummary);
            $this.find(".row.today .weather-info .switch-on-hover .show-on-hover").text(data.today.summary);

            var dayList = $this.find(".wetter-box > ul");
            dayList.html("");

            dayList.append(`<li class="day">
                <div class="text">${tomorrow}</div>
                <canvas class="weather-icon tomorrow" width="65" height="65" data-icon="${data.tomorrow.icon}"></canvas>
                <div class="temperature small">
                    <span class="min">${data.tomorrow.temperatureMin}</span>
                    <span class="max">${data.tomorrow.temperatureMax}</span>
                </div>
            </li>`);

            dayList.append(`<li class="day">
                <div class="text">${overtomorrow}</div>
                <canvas class="weather-icon after-tomorrow" width="65" height="65" data-icon="${data.afterTomorrow.icon}"></canvas>
                <div class="temperature small">
                    <span class="min">${data.afterTomorrow.temperatureMin}</span>
                    <span class="max">${data.afterTomorrow.temperatureMax}</span>
                </div>
            </li>`);

            $this.find(".weather-icon").each(function(){
                window.pixelpoint.ppComponents.skyCons.init($(this));
            });

        });
    });
});